const validateAdvocateRegistrationForm = (data) => {
  let errors = {};

  // Validate name
  if (!data.name || data.name.trim() === '') {
    errors.name = 'Name is required';
  }

  // Validate relationshipType
  if (!data.relationshipType || data.relationshipType.trim() === '') {
    errors.relationshipType = 'Relationship Type is required';
  }

  // Validate relativeName
  if (!data.relativeName || data.relativeName.trim() === '') {
    errors.relativeName = 'Relative Name is required';
  }

  // Validate dateOfBirth (basic format check)
  if (!data.dateOfBirth || !isValidDate(data.dateOfBirth)) {
    errors.dateOfBirth = 'Invalid date of birth';
  }

  // Validate advocateBarId
  if (!data.advocateBarId || data.advocateBarId.trim() === '') {
    errors.advocateBarId = 'Advocate Bar ID is required';
  }

  // Validate registrationDate (basic format check)
  if (!data.registrationDate || !isValidDate(data.registrationDate)) {
    errors.registrationDate = 'Invalid registration date';
  }

  // Validate mobileNo
  if (!data.mobileNo || !isValidMobileNumber(data.mobileNo)) {
    errors.mobileNo = 'Invalid mobile number';
  }

  // Validate email
  if (!data.email || !isValidEmail(data.email)) {
    errors.email = 'Invalid email address';
  }

  // Validate permanentAddress
  if (!data.permanentAddress || data.permanentAddress.trim() === '') {
    errors.permanentAddress = 'Permanent Address is required';
  }

  // Validate bloodGroup
  if (!data.bloodGroup || data.bloodGroup.trim() === '') {
    errors.bloodGroup = 'Blood Group is required';
  }

  // Validate mentorAdvocateName
  if (!data.mentorAdvocateName || data.mentorAdvocateName.trim() === '') {
    errors.mentorAdvocateName = 'Mentor Advocate Name is required';
  }

  // Validate mentorAdvocateBarId
  if (!data.mentorAdvocateBarId || data.mentorAdvocateBarId.trim() === '') {
    errors.mentorAdvocateBarId = 'Mentor Advocate Bar ID is required';
  }

  // Validate mentorJoiningDate (basic format check)
  if (!data.mentorJoiningDate || !isValidDate(data.mentorJoiningDate)) {
    errors.mentorJoiningDate = 'Invalid mentor joining date';
  }

  // Validate chamberNo
  if (!data.chamberNo || data.chamberNo.trim() === '') {
    errors.chamberNo = 'Chamber Number is required';
  }

  // Validate retirementYear (greater than zero)
  if (data.retirementYear && data.retirementYear <= 0) {
    errors.retirementYear = 'Retirement Year is Required';
  }

  // Validate high school details
  if (!data.highSchoolDegree || data.highSchoolDegree.trim() === '') {
    errors.highSchoolDegree = 'High School Degree is required';
  }
  if (data.highSchoolPassingYear <= 0) {
    errors.highSchoolPassingYear = 'High School Passing Year is Required';
  }
  if (!data.highSchoolDetails || data.highSchoolDetails.trim() === '') {
    errors.highSchoolDetails = 'High School Details are required';
  }

  // Validate intermediate details
  if (!data.intermediateDegree || data.intermediateDegree.trim() === '') {
    errors.intermediateDegree = 'Intermediate Degree is required';
  }
  if (data.intermediatePassingYear <= 0) {
    errors.intermediatePassingYear = 'Intermediate Passing Year is Required';
  }
  if (!data.intermediateDetails || data.intermediateDetails.trim() === '') {
    errors.intermediateDetails = 'Intermediate Details are required';
  }

  // Validate graduation details
  if (!data.graduationDegree || data.graduationDegree.trim() === '') {
    errors.graduationDegree = 'Graduation Degree is required';
  }
  if (data.graduationPassingYear <= 0) {
    errors.graduationPassingYear = 'Graduation Passing Year is Required';
  }
  if (!data.graduationDetails || data.graduationDetails.trim() === '') {
    errors.graduationDetails = 'Graduation Details are required';
  }

  // // Validate post graduation details
  // if (!data.postGraduationDegree || data.postGraduationDegree.trim() === '') {
  //   errors.postGraduationDegree = 'Post Graduation Degree is required';
  // }

  // if (data.postGraduationPassingYear <= 0) {
  //   errors.postGraduationPassingYear = 'Post Graduation Passing Year is Required';
  // }
  // if (!data.postGraduationDetails || data.postGraduationDetails.trim() === '') {
  //   errors.postGraduationDetails = 'Post Graduation Details are required';
  // }

  // // Validate doctorate details
  // if (!data.doctrateDegree || data.doctrateDegree.trim() === '') {
  //   errors.doctrateDegree = 'Doctorate Degree is required';
  // }
  // if (data.doctratePassingYear <= 0) {
  //   errors.doctratePassingYear = 'Doctorate Passing Year is Required';
  // }
  // if (!data.doctrateDetails || data.doctrateDetails.trim() === '') {
  //   errors.doctrateDetails = 'Doctorate Details are required';
  // }

  // File size limit in bytes (3 MB)
  const FILE_SIZE_LIMIT = 3 * 1024 * 1024;

  // Validate files
  const validateFile = (file, fieldName) => {
    if (!file) {
      errors[fieldName] = `${fieldName.replace(/([A-Z])/g, ' $1')} is required`;
    } else {
      if (file.size > FILE_SIZE_LIMIT) {
        errors[fieldName] = `${fieldName.replace(/([A-Z])/g, ' $1')} size must be less than 3 MB`;
      }
      if (file.type !== 'application/pdf') {
        errors[fieldName] = `${fieldName.replace(/([A-Z])/g, ' $1')} must be a PDF`;
      }
    }
  };

  validateFile(data.highSchoolDocument, 'highSchoolDocument');
  validateFile(data.intermediateDocument, 'intermediateDocument');
  validateFile(data.graduationDocument, 'graduationDocument');
  if (data.postGraduationDocument) {
    validateFile(data.postGraduationDocument, 'postGraduationDocument');
  }

  if (data.doctrateDocument) {
    validateFile(data.doctrateDocument, 'doctrateDocument');
  }
  
  // validateFile(data.postGraduationDocument, 'postGraduationDocument');
  // validateFile(data.doctrateDocument, 'doctrateDocument');
  validateFile(data.aadharDocument, 'aadharDocument');
  validateFile(data.affidavitDocument, 'affidavitDocument');
  validateFile(data.aibeCertificate, 'aibeCertificate');

  // Return the errors object
  return errors;
};

// Basic date format validation (YYYY-MM-DD)
const isValidDate = (dateString) => {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  return regex.test(dateString);
};

// Basic mobile number validation (10 digits)
const isValidMobileNumber = (mobileNumber) => {
  const regex = /^\d{10}$/;
  return regex.test(mobileNumber);
};

// Basic email validation
const isValidEmail = (email) => {
  const regex = /\S+@\S+\.\S+/;
  return regex.test(email);
};






export default validateAdvocateRegistrationForm;
